/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { TaskSuggestion } from './TaskSuggestion.js';
import {
    TaskSuggestionFromJSON,
    TaskSuggestionFromJSONTyped,
    TaskSuggestionToJSON,
} from './TaskSuggestion.js';

/**
 * 
 * @export
 * @interface SingleTaskSuggestionResponse
 */
export interface SingleTaskSuggestionResponse {
    /**
     * 
     * @type {TaskSuggestion}
     * @memberof SingleTaskSuggestionResponse
     */
    data?: TaskSuggestion;
    /**
     * 
     * @type {number}
     * @memberof SingleTaskSuggestionResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof SingleTaskSuggestionResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof SingleTaskSuggestionResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof SingleTaskSuggestionResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the SingleTaskSuggestionResponse interface.
 */
export function instanceOfSingleTaskSuggestionResponse(value: object): boolean {
    return true;
}

export function SingleTaskSuggestionResponseFromJSON(json: any): SingleTaskSuggestionResponse {
    return SingleTaskSuggestionResponseFromJSONTyped(json, false);
}

export function SingleTaskSuggestionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SingleTaskSuggestionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : TaskSuggestionFromJSON(json['data']),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function SingleTaskSuggestionResponseToJSON(value?: SingleTaskSuggestionResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': TaskSuggestionToJSON(value['data']),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

